import React from "react";

const Missing = () => {
    return (
        <main>
            <h2>Page Not Found</h2>
        </main>
    )
}

export default Missing;